module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PageInfo', [(_vm.hasContent) ? _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c9420a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/card/info/component.vue
// module id = fa369aa2fff117b87bc8
// module chunks = 1